(function () {
  var header = document.querySelector('.aw-header');
  if (!header) return;

  var setHeaderHeight = function () {
    document.documentElement.style.setProperty('--aw-header-height', header.offsetHeight + 'px');
  };

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  if (window.ResizeObserver) {
    new ResizeObserver(setHeaderHeight).observe(header);
  }
})();
